import { CreateCustomerProfileDto } from '../../../api/models/CreateCustomerProfileDto';
import { format, isValid } from 'date-fns';
import { es as esLocale } from 'date-fns/locale';
import type { CustomerSalesHistoryItem } from '../../../types/sales.types';
import type { ClientDrawerFormState } from './clientCreateDrawer.types';

export function formatMoneyBo(value: number): string {
  return new Intl.NumberFormat('es-BO', {
    style: 'currency',
    currency: 'BOB',
    maximumFractionDigits: 2,
  }).format(value);
}

export function getGenderDisplayLabel(gender: ClientDrawerFormState['gender']): string {
  if (gender === CreateCustomerProfileDto.gender.MALE) return 'Masculino';
  if (gender === CreateCustomerProfileDto.gender.FEMALE) return 'Femenino';
  if (gender === CreateCustomerProfileDto.gender.OTHER) return 'Otro';
  return '-';
}

export function getPaymentMethodDisplayLabel(
  method: ClientDrawerFormState['preferredPaymentMethod'],
): string {
  if (method === CreateCustomerProfileDto.preferredPaymentMethod.CASH) return 'Efectivo';
  if (method === CreateCustomerProfileDto.preferredPaymentMethod.CARD) return 'Tarjeta';
  if (method === CreateCustomerProfileDto.preferredPaymentMethod.BANK_TRANSFER) {
    return 'Transferencia';
  }
  if (method === CreateCustomerProfileDto.preferredPaymentMethod.QR_CODE) return 'Código QR';
  return '-';
}

export function getLoyaltyTierDisplayLabel(tier: ClientDrawerFormState['loyaltyTier']): string {
  if (tier === CreateCustomerProfileDto.loyaltyTier.BRONZE) return 'Bronce';
  if (tier === CreateCustomerProfileDto.loyaltyTier.SILVER) return 'Plata';
  if (tier === CreateCustomerProfileDto.loyaltyTier.GOLD) return 'Oro';
  return 'Platino';
}

export function postSaleStatusChip(status: CustomerSalesHistoryItem['postSaleStatus']): {
  label: string;
  color: 'default' | 'warning' | 'info' | 'error';
} {
  if (status === 'REFUNDED_AND_EXCHANGED') {
    return { label: 'Devuelto + Intercambio', color: 'error' };
  }
  if (status === 'REFUNDED') {
    return { label: 'Devuelto', color: 'warning' };
  }
  if (status === 'EXCHANGED') {
    return { label: 'Intercambio', color: 'info' };
  }
  return { label: 'Sin postventa', color: 'default' };
}

export function formatSalesHistoryDate(date: Date): string {
  const parsed = date instanceof Date ? date : new Date(date);
  if (!isValid(parsed)) return '-';
  return format(parsed, 'dd/MM/yyyy HH:mm', { locale: esLocale });
}
